// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"8b9d34f8","209":"f565d9cc","223":"49759592","255":"7ced442b","458":"e5dd0dc6","698":"93a41de2"}[chunkId] + ".chunk.js";
};